import { KeyValueCustomMultipleSelect, TeamPill } from "@smartsuite/react-ui/lib";
import { Team as SmartSuiteTeam } from "@smartsuite/types";
import React from "react";
import { Team } from "../../../../types/form";
import { $t } from "../../../../utils/intl";
import { UseFormFieldResult } from "../../../../hooks/useFormField";
import { fieldsStateText, fieldsText } from "../../fields.text";
import { TeamFormValue } from "../team.config";
import { ensureTeamColor } from "./ensureTeamColor";

interface TeamFieldMultipleProps {
  options: TeamFormValue[];
  formField: UseFormFieldResult<Team[]>;
  readOnly?: boolean;
  isLoading: boolean;
}

export const TeamFieldMultiple: React.FunctionComponent<TeamFieldMultipleProps> = ({
  options,
  formField,
  readOnly,
  isLoading,
}) => {
  return (
    <KeyValueCustomMultipleSelect<"team", "name", TeamFormValue>
      inputGroupClassname="team-field-multiple-select"
      inputBackground="white-new"
      placeholderArrowStyle="arrow-down-smaller"
      placeholderClassMod="forms"
      labelField="name"
      disabled={readOnly}
      isReadOnly={readOnly}
      showDropdownArrow={!readOnly}
      options={options}
      placeholder={
        isLoading ? $t(fieldsStateText.loading) : $t(fieldsText.multipleSelectPlaceholder)
      }
      renderSelectedOption={(option) => (
        <TeamPill team={ensureTeamColor(option.team) as unknown as SmartSuiteTeam} />
      )}
      renderOption={(option) => (
        <TeamPill team={ensureTeamColor(option.team) as unknown as SmartSuiteTeam} />
      )}
      searchPlaceholder={$t(fieldsText.multipleSelectSearchOptionPlaceholder)}
      showFilterGreaterThan={4}
      state={formField.state}
      value={formField.value}
      valueField="team"
      valueFieldPath="id"
      virtualized={true}
      itemHeight={36}
      itemGap={2}
      onChange={formField.onChange}
      onChangeFocused={formField.onChangeFocused}
    />
  );
};
